"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toRGBA = void 0;
/**
 * hex to rgba
 * @see https://www.w3schools.com/css/css3_colors.asp
 * @param  hex   
 * @param   alpha (default = 1, fully opaque)
 * @return rgba css command
 */

var toRGBA = function toRGBA(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return "rgba(".concat(parseInt(hex.substring(1, 3), 16), ",").concat(parseInt(hex.substring(3, 5), 16), ",").concat(parseInt(hex.substring(5, 7), 16), ",").concat(alpha, ")");
};

exports.toRGBA = toRGBA;